import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useSaveOption = function () {
    return useApiCall(function (signal, payload) { return api.option.apiOptionDataPost(payload, { signal: signal }); }, {}, true);
};
